import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ReportFilters = ({ filters, onFilterChange, onClearFilters, referrals }) => {
  const dateRangeOptions = [
    { value: 'last30days', label: 'Derniers 30 jours' },
    { value: 'last3months', label: 'Dernier trimestre' },
    { value: 'last6months', label: 'Derniers 6 mois' },
    { value: 'lastyear', label: 'Dernière année' },
    { value: 'custom', label: 'Période personnalisée' }
  ];

  const statusOptions = [
    { value: 'all', label: 'Tous les statuts' },
    { value: 'new', label: 'Nouveau' },
    { value: 'reviewed', label: 'En revue' },
    { value: 'scheduled', label: 'Programmé' },
    { value: 'completed', label: 'Terminé' },
    { value: 'cancelled', label: 'Annulé' }
  ];

  const referralReasonOptions = [
    { value: 'all', label: 'Tous les motifs' },
    { value: 'Traitement endodontique initial', label: 'Traitement initial' },
    { value: 'Retraitement endodontique', label: 'Retraitement' },
    { value: 'Chirurgie endodontique', label: 'Chirurgie' },
    { value: 'Traumatisme dentaire', label: 'Traumatisme' },
    { value: 'Douleur persistante', label: 'Douleur persistante' },
    { value: 'Autre', label: 'Autre' }
  ];

  // Extract unique dentist names
  const uniqueDentists = [...new Set(referrals?.map(r => r?.referringDentistName)?.filter(Boolean))];
  const dentistOptions = [
    { value: 'all', label: 'Tous les dentistes' },
    ...uniqueDentists?.map(name => ({ value: name, label: name }))
  ];

  const hasActiveFilters = 
    filters?.dateRange !== 'last30days' ||
    filters?.referringDentist !== 'all' ||
    filters?.toothNumber ||
    filters?.referralReason !== 'all' ||
    filters?.treatmentOutcome !== 'all' ||
    filters?.status !== 'all';

  return (
    <div className="bg-[rgba(26,26,30,0.95)] backdrop-blur-2xl border border-white/10 p-6 rounded-2xl shadow-2xl">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-blue-500/10 flex items-center justify-center">
            <Icon name="Filter" size={20} className="text-blue-400" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-white">Filtres Avancés</h2>
            <p className="text-sm text-gray-400">Affinez votre analyse</p>
          </div>
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            className="text-gray-300 hover:text-white"
          >
            Réinitialiser
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Date Range */}
        <Select
          label="Période"
          options={dateRangeOptions}
          value={filters?.dateRange}
          onChange={(value) => onFilterChange({ dateRange: value })}
        />

        {/* Custom Date Range */}
        {filters?.dateRange === 'custom' && (
          <>
            <Input
              label="Date de début"
              type="date"
              value={filters?.customDateFrom}
              onChange={(e) => onFilterChange({ customDateFrom: e?.target?.value })}
            />
            <Input
              label="Date de fin"
              type="date"
              value={filters?.customDateTo}
              onChange={(e) => onFilterChange({ customDateTo: e?.target?.value })}
            />
          </>
        )}

        {/* Referring Dentist */}
        <Select
          label="Dentiste adresseur"
          options={dentistOptions}
          value={filters?.referringDentist}
          onChange={(value) => onFilterChange({ referringDentist: value })}
          searchable={dentistOptions?.length > 5}
        />

        {/* Tooth Number */}
        <Input
          label="Numéro de dent"
          placeholder="Ex: 16, 21..."
          value={filters?.toothNumber}
          onChange={(e) => onFilterChange({ toothNumber: e?.target?.value })}
        />

        {/* Referral Reason */}
        <Select
          label="Motif d'adressage"
          options={referralReasonOptions}
          value={filters?.referralReason}
          onChange={(value) => onFilterChange({ referralReason: value })}
        />

        {/* Status */}
        <Select
          label="Statut du traitement"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange({ status: value })}
        />
      </div>
    </div>
  );
};

export default ReportFilters;